import React from 'react';

export default class SearchResult extends React.Component {
  render() {
    return (
      <div className="search-result">
        <a className="search-result__title" href={this.props.values.url}>{this.props.values.title}</a>
        <span className="search-result__url">{this.props.values.url}</span>
        <p className="search-result__description">{this.props.values.description}</p>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/SearchResult.js